<template>
  <div reporter-module="related_products" reporter-appear reporter-appear-duration v-if="props.productList?.length">
    <v-row no-gutters class="d-none d-md-flex justify-center">
      <v-col cols="12">
        <p class="fs-18 fb-650 text-center mt-4 fc-black">{{ title }}</p>
        <div class="project-swiper my-5">
          <swiper
            loop
            @swiper="onSwiper"
            :slidesPerView="5"
            :slidesPerGroup="5"
            :spaceBetween="20"
            :loop="false"
            :centeredSlides="false"
            :autoplay="{ delay: 2000, disableOnInteraction: false }"
            class="mySwiper"
            limit="100"
          >
            <swiper-slide v-for="(item, i) in props.productList" :key="i">
              <div>
                <shopmall-product-item
                  :productInfo="item"
                  showTag
                ></shopmall-product-item>
              </div>
            </swiper-slide>
          </swiper>
          <div
            class="button-prev btn"
            @click.stop="prevEl"
            v-if="props.productList.length > 5"
          >
            <v-icon class="mdi mdi-chevron-left" size="50"></v-icon>
          </div>
          <div
            class="button-next btn"
            @click.stop="nextEl"
            v-if="props.productList.length > 5"
          >
            <v-icon class="mdi mdi-chevron-right" size="50"></v-icon>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";

// 定义props productList，类型是数组，默认值是[]
const props = defineProps({
  productList: {
    type: Array,
    default: () => []
  },
  title: {
    type: String,
    default: "Related products"
  }
});

const { $Reporter } = useNuxtApp()

const route = useRoute();

let useSwiper = reactive(null); // swiper实例

// 初始化swiper
const onSwiper = swiper => {
  useSwiper = swiper;
};

const prevEl = () => {
  if(route.name === 'my-cart') {
    $Reporter.click({event: 'e_my_cart_product_carousel_toggle'})
  }else if(route.name === 'product-id') {
    $Reporter.click({event: 'e_product_detail_product_carousel_toggle'})
  }
  useSwiper.slidePrev();
};
const nextEl = () => {
  if(route.name === 'my-cart') {
    $Reporter.click({event: 'e_my_cart_product_carousel_toggle'})
  }else if(route.name === 'product-id') {
    $Reporter.click({event: 'e_product_detail_product_carousel_toggle'})
  }
  useSwiper.slideNext();
};
</script>

<style scoped lang="scss">
.product-container {
  padding: 0;
  small {
    font-size: 14px;
  }
  .sort {
    p {
      line-height: 44px;
    }
  }
  .pc {
    .v-input {
      max-width: 260px;
    }
  }
  .menu-title {
    background-color: #f2f2f2;
  }
}
.sp-product-item-wrapper {
  padding: 10px;
}
.project-swiper {
  margin: 0 -10px;
  position: relative;
  .btn {
    position: absolute;
    top: 30%;
    height: 60px;
    width: 45px;
    background: white;
    opacity: 0.7;
    cursor: pointer;
    border-radius: 2px;
    line-height: 60px;
    text-indent: -3px;
  }
  .btn:hover {
    opacity: 1;
  }
  .button-prev {
    left: -60px;
  }
  .button-next {
    right: -60px;
  }
}
</style>
